import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { MicrosoftState } from './MicrosoftState.js';

/**
 * Represents the state of a group in Microsoft Graph. By comparing the fields in the database with the fields in the Microsoft Graph API response, this entity can determine whether a group is in sync with the Microsoft Graph API.
 */
@Entity()
export class MicrosoftGroupState extends MicrosoftState {
  static override _class = 'MicrosoftGroupState';

  constructor(doc: PartialEntityData<MicrosoftGroupState>) {
    super(doc);
  }

  @Field(type => String)
  groupID: Maybe<string>;

  @Field(type => String)
  displayName: Maybe<string>;

  @Field(type => String)
  description: Maybe<string>;

  @Field(type => String)
  mailNickname: Maybe<string>;

  @Field(type => String)
  mail: Maybe<string>;

  @Field(type => Boolean)
  securityEnabled: Maybe<boolean>;

  @Field(type => Boolean)
  mailEnabled: Maybe<boolean>;

  @Field(type => String)
  visibility: Maybe<'Private' | 'Public'>;

  @Field(type => [String], { default: v => v ?? [] })
  memberIDs: Maybe<string[]>;
}
